/* eslint-disable jsx-a11y/label-has-for */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import config from '../../../config';
import axios from 'axios';
import withErrorNotification from '../../../hof/withErrorNotification';
import { Images } from '../../../services/Images';

class FileInputField extends PureComponent {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([
            PropTypes.shape({
                name: PropTypes.string,
            }),
            PropTypes.string,
        ]),
    };

    static defaultProps = {
        value: null,
    };

    constructor(props) {
        super(props);
        this.onDrop = this.onDrop.bind(this);
        this.fileInput = React.createRef() // ref to fileInput
        this.state = {
            loading: false,
            link: ''
        };
        // this.onDrop = this.onDrop.bind(this);
    }

    async uploadFileAsync(buffer, filename) {

        let formData = new FormData();
        formData.append('file', new Blob([buffer]), filename ? filename : 'image');

        const options = {
            url: `${config.API_ADDR}/images`,
            method: 'POST',
            data: formData,
            headers: {
                'content-type': 'multipart/form-data'
            }
        }
        const {data: {link}} = await axios(options);
        return link;

    }

    async onDrop(files) {
        await withErrorNotification(async () => {
            try {
                const {onChange} = this.props;

                this.setState({loading: true});

                for (let file of files) {
                    const content = await Images.readFile(file);
                    const link = await Images.uploadFile(content);
                    console.log(link);
                    this.setState({link: link});
                    onChange(link);
                }

                this.setState({loading: false});
            } catch (e) {
                console.error(e);
                throw new Error('File is invalid or too big');
            }
        }, () => {
            this.setState({loading: false});
        });
    }

    componentDidMount() {
        const {value} = this.props;
        if (value) {
            this.setState({link: value});
        }
    }

    componentWillReceiveProps(nextProps) {
        const {value} = nextProps;
        if (value) {
            this.setState({link: value});
        }
    }

    render() {
        const {onChange, name, t} = this.props;

        return (
            <InputGroup>
                <input hidden={true} accept="image/x-png,image/gif,image/jpeg" type="file" ref={this.fileInput}
                       onChange={(e) => this.onDrop(e.target.files)}/>
                <Input
                    placeholder="https://..."
                    type="text"
                    name={name}
                    value={this.state.link}
                    onChange={(event) => {
                        this.setState({link: event.target.value});
                        onChange(event.target.value);
                    }}
                />
                <InputGroupAddon addonType="append">
                    <Button
                        className={`form__form-group-button`}
                        color="success"
                        size="sm"
                        onClick={() => {
                            this.fileInput.current.click();
                        }}
                    >Select</Button>
                </InputGroupAddon>
            </InputGroup>
        );
    }
}

const renderFileInputField = (props) => {
    const {input, meta} = props;
    return (
        <div className="form__form-group-input-wrap">
            <FileInputField {...input} />
            {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
        </div>
    );
};

renderFileInputField.propTypes = {
    input: PropTypes.shape({
        onChange: PropTypes.func,
        name: PropTypes.string,
    }).isRequired,
    meta: PropTypes.shape({
        touched: PropTypes.bool,
        error: PropTypes.string,
    }),
};

renderFileInputField.defaultProps = {
    meta: null,
};

export default renderFileInputField;
